/* Ausgeknipst Bewertungen (#1501, erweitert #2760): Produktseite, Sammelseite, Karussell unter dem Titel, Startseiten-Banner und
   -Karussell, Übersetzen-Knopf, Fotoansicht.
   Daten: <api>/api/public/reviews (Liste, Sortieren, Filtern) · /api/public/summary (Inhalt der Metafelder, wenn sie fehlen) ·
   /api/public/translation (Übersetzung auf Klick). Nur veröffentlichte Bewertungen, nur öffentliche Felder.
   Die serverseitigen Karten (snippets/ak-reviews-card.liquid, -summary, -carousel, sections/*) und die Bausteine hier müssen
   gleich aussehen: wer das eine ändert, ändert das andere mit. Kundentext wird hier immer über esc() eingesetzt. */
(function () {
  'use strict';
  if (window.__akReviews) return; // Section und Snippets binden das Skript mehrfach ein
  window.__akReviews = true;

  var I18N = {};
  try { I18N = JSON.parse((document.querySelector('script[data-ak-i18n]') || {}).textContent || '{}'); } catch (e) { I18N = {}; }
  function t(key, vals) {
    var s = I18N[key] || '';
    if (vals) Object.keys(vals).forEach(function (k) { s = s.split('__' + k + '__').join(String(vals[k])); }); // Platzhalter aus snippets/ak-reviews-i18n.liquid
    return s;
  }
  function tn(base, n, vals) { var v = vals || {}; v.n = n; return t(base + (n === 1 ? '_one' : '_other'), v); }

  /* Wie Liquids „!= blank“: nur Leerzeichen gilt als leer. */
  function hat(s) { return s != null && String(s).trim() !== ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* Wie Liquids newline_to_br: Shopify setzt <br /> und behält den Umbruch — sonst weichen SSR und Skript ab. */
  function nl2br(s) { return esc(s).replace(/\r?\n/g, '<br />\n'); }
  function dec1(r, loc) { var s = (Math.round(Number(r || 0) * 10) / 10).toFixed(1); return loc === 'en' ? s : s.replace('.', ','); }
  function pctText(p, loc) { return loc === 'en' ? p + '%' : p + ' %'; }
  /* Wie Liquid: de 15.09.2026, sonst 15/09/2026. */
  function fmtDate(iso, loc) { var p = String(iso || '').split('-'); return p.length === 3 ? esc(loc === 'de' ? p[2] + '.' + p[1] + '.' + p[0] : p[2] + '/' + p[1] + '/' + p[0]) : esc(iso); }
  function apiOf(el) { return (el.getAttribute('data-api') || 'https://bewerten.ausgeknipst.de').replace(/\/$/, ''); }

  var cache = {};
  function getJSON(url, shared) {
    if (shared && cache[url]) return cache[url];
    var p = fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    if (shared) { cache[url] = p; p.catch(function () { delete cache[url]; }); }
    return p;
  }

  /* Sterne wie snippets/ak-reviews-stars.liquid: fünf Felder, volle Form in Judge.mes Gold, halbe zur Hälfte gefüllt. */
  function stars(rating, size) {
    // Rest auf zwei Stellen runden: 4.7 − 4 ergibt in Gleitkomma 0.7000000000000002 und hätte einen vollen statt halben Stern ergeben
    var r = Number(rating) || 0, full = Math.floor(r), rest = Math.round((r - full) * 100) / 100, half = 0;
    if (rest >= 0.3 && rest <= 0.7) half = full + 1; else if (rest > 0.7) full += 1;
    var h = '';
    for (var i = 1; i <= 5; i++) h += '<i class="ak-star' + (i <= full ? ' ak-star--on' : i === half ? ' ak-star--half' : '') + '" aria-hidden="true"></i>';
    return '<span class="ak-stars' + (size ? ' ak-stars--' + size : '') + '" role="img" aria-label="' + esc(t('star_info', { rating: Math.round(r * 10) / 10 })) + '">' + h + '</span>';
  }

  function summaryHaken(p) {
    var wort = esc(t('fact_verified', { percent: p }));
    return '<span class="ak-review__verified" title="' + wort + '"><span class="visually-hidden">' + wort + '</span></span>';
  }

  function summaryHTML(d, loc, link) {
    var avg = dec1(d.rating, loc), count = d.count || 0, line = esc(t('rating_of_5', { rating: avg }));
    var h = '<div class="ak-summary"><div class="ak-summary__avg"><p class="ak-summary__rating">' + stars(d.rating, 'lg') +
      '<span class="ak-summary__line">' + (link ? '<a href="' + esc(link) + '">' + line + '</a>' : line) + '</span></p>' +
      // „Basierend auf 45 Bewertungen“ mit Haken, beim Darüberfahren der Anteil verifizierter Bewertungen (Vladi 17.09.2026, wie Judge.me)
      '<p class="ak-summary__count">' + esc(tn('based_on', count)) + (d.verified && count ? summaryHaken(Math.floor(d.verified * 100 / count)) : '') + '</p>' +
      // Testerbewertungen zählen mit, ihre Zahl steht darunter (#2790, wie snippets/ak-reviews-summary.liquid)
      (d.tester ? '<p class="ak-summary__note">' + esc(tn('tester_note', d.tester)) + '</p>' : '') +
      // Kein Amazon-Hinweis am Schnitt (Vladi 16.09.2026): die Kennzeichnung steht an jeder Bewertung
      (d.group && d.group.length > 1 ? '<p class="ak-summary__note">' + esc(t('group_note', { products: d.group.map(function (g) { return g.title; }).join(' · ') })) + '</p>' : '') + '</div>' +
      '<ul class="ak-histogram" aria-label="' + esc(t('histogram')) + '">';
    for (var star = 5; star >= 1; star--) {
      var n = (d.histogram || [])[star - 1] || 0, p = count ? Math.round(n * 100 / count) : 0, st = tn('stars', star), ps = pctText(p, loc);
      h += '<li><button type="button" class="ak-histogram__row" data-ak-star="' + star + '" aria-pressed="false" aria-label="' + esc(t('filter_by_stars', { stars: st })) + ': ' + esc(ps) + '"' + (n ? '' : ' disabled') + '>' +
        '<span class="ak-histogram__label">' + stars(star, 'sm') + '</span><span class="ak-histogram__track"><span class="ak-histogram__fill" style="width: ' + p + '%"></span></span>' +
        '<span class="ak-histogram__pct">' + esc(ps) + '</span></button></li>';
    }
    return h + '</ul></div>';
  }

  function factsHTML(s) {
    var p = s.count ? Math.floor(s.verified * 100 / s.count) : 0;
    // Nur Anteil verifizierter Bewertungen und der Link zur Erklärung (Vladi 17.09.2026: Fotos-, Antworten-Zahl und „seit“ unnötig)
    return '<ul class="ak-facts"><li>' + esc(t('fact_verified', { percent: p })) + '</li><li><a href="#transparenz">' + esc(t('how_link')) + '</a></li></ul>';
  }

  /* Vorschaubild wie snippets/ak-reviews-thumb.liquid: trägt alles, was die Fotoansicht daneben zeigt.
     m = { kind, url, thumb }, r = { id, name, rating, title, date, body, language, verified, verifiedBy, product, tester }. */
  function thumbButton(m, r, loc, large) {
    // Video ohne Vorschaubild: das erste Bild des Videos selbst zeigen (Vladi 16.09.2026)
    var inner = m.kind === 'video' && !hat(m.thumb)
      ? '<video src="' + esc(m.url) + '#t=0.1" preload="metadata" muted playsinline aria-hidden="true" tabindex="-1"></video>'
      : '<img src="' + esc(m.thumb || m.url) + '" alt="" loading="lazy" width="' + (large ? 120 : 96) + '" height="' + (large ? 120 : 96) + '">';
    return '<li><button type="button" class="ak-thumb' + (large ? ' ak-thumb--lg' : '') + (m.kind === 'video' ? ' ak-thumb--video' : '') + '" data-ak-media' +
      ' data-kind="' + esc(m.kind) + '" data-src="' + esc(m.url) + '" data-review="' + esc(r.id) + '"' +
      ' data-name="' + esc(r.name) + '" data-rating="' + Number(r.rating) + '" data-date="' + esc(r.date) + '" data-date-text="' + fmtDate(r.date, loc) + '"' +
      (hat(r.title) ? ' data-title="' + esc(r.title) + '"' : '') + ' data-body="' + esc(r.body) + '" data-lang="' + esc(r.language) + '"' +
      (r.verified ? ' data-verified="' + esc(r.verifiedBy || 'judgeme') + '"' : '') + (r.amazon ? ' data-source="amazon"' : r.shop ? ' data-source="shop"' : '') + (r.tester ? ' data-tester="1"' : '') +
      (r.product && hat(r.product.title) ? ' data-product="' + esc(t('review_for', { product: r.product.title })) + '"' : '') +
      ' aria-label="' + esc(t('open_media', { name: r.name })) + '">' + inner + '</button></li>';
  }

  /* Galerie-Einträge tragen die Bewertungsfelder flach (lib/anzeige-plan.ts, galerie) samt vollem Text. */
  function galleryHTML(items, loc) {
    if (!items || !items.length) return '';
    return '<div class="ak-gallery"><p class="ak-gallery__title">' + esc(t('photos')) + '</p><ul class="ak-gallery__strip" data-ak-media-group>' +
      items.map(function (m) {
        return thumbButton(m, { id: m.review, name: m.name, rating: m.rating, title: m.title, date: m.date, body: m.body, language: m.language, verified: m.verified, verifiedBy: m.verifiedBy, product: m.product, tester: m.tester, shop: m.shop }, loc, true);
      }).join('') + '</ul></div>';
  }

  /* Karussells: Haken im Kreis, das Wort als title und unsichtbar für Vorleseprogramme (snippets/ak-reviews-carousel, sections/ak-reviews-featured) */
  function verifiedLabel(r) {
    if (!r.verified) return '';
    var wort = esc(t(r.verifiedBy === 'order' ? 'verified' : 'verified_legacy'));
    return '<span class="ak-review__verified" title="' + wort + '"><span class="visually-hidden">' + wort + '</span></span>';
  }

  /* Liste und Fotoansicht: Schild mit dem Wort rechts neben dem Namen, wie Judge.me (snippets/ak-reviews-card.liquid) */
  function verifiedText(r) {
    return r.verified ? '<span class="ak-review__verified-text">' + esc(t(r.verifiedBy === 'order' ? 'verified' : 'verified_legacy')) + '</span>' : '';
  }

  function productImage(url) { return url ? url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=80' : ''; }

  /* Karte wie snippets/ak-reviews-card.liquid; auf der Sammelseite zusätzlich das Produkt darüber, in einer Produktgruppe „Bewertung zu …“. */
  function card(r, loc, opts) {
    var h = '<li class="ak-review" id="bewertung-' + esc(r.id) + '" data-review-id="' + esc(r.id) + '" data-lang="' + esc(r.language) + '">';
    if (opts.withProduct && r.product) {
      var img = r.product.image ? '<img src="' + esc(productImage(r.product.image)) + '" alt="" loading="lazy" width="40" height="40">' : '';
      h += r.product.active
        ? '<a class="ak-review__product" href="' + esc(opts.root + '/products/' + r.product.handle) + '">' + img + '<span>' + esc(r.product.title) + '</span></a>'
        : '<p class="ak-review__product">' + img + '<span>' + esc(r.product.title) + '</span></p>';
    }
    // Name bis Text in .ak-review__main: daneben stehen am Computer die Fotos in genau dieser Höhe (#3194)
    h += '<div class="ak-review__main"><p class="ak-review__name">' + esc(r.name) + verifiedText(r) + '</p>';
    h += '<div class="ak-review__rating">' + stars(r.rating, 'sm') + '</div>';
    if (hat(r.title)) h += '<h3 class="ak-review__title" data-ak-title>' + esc(r.title) + '</h3>';
    h += '<p class="ak-review__meta"><time datetime="' + esc(r.date) + '">' + fmtDate(r.date, loc) + '</time>' +
      (r.shop ? '<span class="ak-review__shop">' + esc(t('shop_review')) + '</span>' : '') +
      (r.amazon ? '<span class="ak-review__source">' + esc(t('amazon_review')) + '</span>' : '') +
      (r.tester ? '<span class="ak-review__source">' + esc(t('tester')) + '</span>' : '') + '</p>';
    if (!opts.withProduct && r.product) h += '<p class="ak-review__for">' + esc(t('review_for', { product: r.product.title })) + '</p>';
    h += '<p class="ak-review__body" data-ak-text>' + nl2br(r.body) + '</p></div>';
    if (r.media && r.media.length) h += '<ul class="ak-review__media" data-ak-media-group>' + r.media.map(function (m) { return thumbButton(m, r, loc, false); }).join('') + '</ul>';
    if (r.language !== loc) h += '<p class="ak-review__translate"><button type="button" class="ak-link" data-ak-translate>' + esc(t('translate')) + '</button> <span class="ak-review__translated" data-ak-translated hidden></span></p>';
    if (r.reply) h += '<div class="ak-review__reply"><p class="ak-review__reply-head">' + esc(t('reply_from')) + ' · <time datetime="' + esc(r.reply.date) + '">' + fmtDate(r.reply.date, loc) + '</time></p><p>' + nl2br(r.reply.text) + '</p></div>';
    return h + '</li>';
  }

  function snippetHTML(h) {
    return '<a class="ak-snippet" href="#bewertungen" data-ak-slide>' +
      (h.image ? '<img class="ak-snippet__image" src="' + esc(h.image.thumb) + '" alt="" loading="lazy" width="64" height="64">' : '') +
      '<span class="ak-snippet__text"><span class="ak-snippet__head">' + stars(h.rating, 'sm') + '<span class="ak-snippet__name">' + esc(h.name) + '</span>' +
      verifiedLabel(h) + '</span>' +
      // Tester-Hinweis (#2790) in derselben Zeile wie „Bewertung für“ (snippets/ak-reviews-carousel.liquid)
      (h.product || h.tester ? '<span class="ak-snippet__for">' + (h.product ? esc(t('review_for', { product: h.product.title })) : '') + (h.product && h.tester ? ' · ' : '') + (h.tester ? esc(t('tester')) : '') + '</span>' : '') +
      (hat(h.title) ? '<span class="ak-snippet__title">' + esc(h.title) + '</span>' : '') + '<span class="ak-snippet__excerpt">' + esc(h.excerpt) + '</span></span></a>';
  }

  function featuredHTML(f, root) {
    var href = esc(root + '/products/' + f.product.handle + '#bewertungen');
    return '<article class="ak-card" data-ak-slide><a class="ak-card__image" href="' + href + '" tabindex="-1" aria-hidden="true"><img src="' + esc(f.image.thumb) + '" alt="" loading="lazy" width="400" height="400"></a>' +
      '<div class="ak-card__body">' + stars(f.rating, 'sm') + '<p class="ak-card__name">' + esc(f.name) + verifiedLabel(f) + '</p>' +
      (hat(f.title) ? '<p class="ak-card__title">' + esc(f.title) + '</p>' : '') + '<p class="ak-card__excerpt">' + esc(f.excerpt) + '</p>' +
      '<a class="ak-card__product" href="' + href + '">' + esc(f.product.title) + '</a></div></article>';
  }

  function bannerHTML(s, loc, page) {
    var avg = dec1(s.rating, loc), p = s.count ? Math.floor(s.verified * 100 / s.count) : 0;
    return '<a class="ak-banner__main" href="' + esc(page) + '"><span class="ak-banner__score">' + avg + '</span>' + stars(s.rating, 'sm') +
      '<span class="ak-banner__text">' + esc(t('rating_line', { rating: avg, reviews: tn('reviews', s.count) })) + '</span></a>' +
      '<a class="ak-banner__how" href="' + esc(page) + '#transparenz">' + esc(t('fact_verified', { percent: p })) + '</a>';
  }

  // ---------------------------------------------------------------- Übersetzen (Karte für Karte, Original bleibt abrufbar)

  var translations = {}; // Bewertungs-ID → { title, body, from }, aus der Liste oder vom Klick

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-ak-translate]');
    if (!btn) return;
    var li = btn.closest('[data-review-id]'), host = btn.closest('[data-api]');
    if (!li || !host) return;
    var id = li.getAttribute('data-review-id'), loc = host.getAttribute('data-locale') || 'de';
    var text = li.querySelector('[data-ak-text]'), title = li.querySelector('[data-ak-title]'), note = li.querySelector('[data-ak-translated]');
    if (li._akOriginal && li.getAttribute('data-ak-showing') === 'translation') {
      text.innerHTML = li._akOriginal.body; text.removeAttribute('lang');
      if (title && li._akOriginal.title != null) title.innerHTML = li._akOriginal.title;
      note.hidden = true; btn.textContent = t('translate'); li.setAttribute('data-ak-showing', 'original');
      kuerzen(text);
      return;
    }
    function show(tr) {
      if (!li._akOriginal) li._akOriginal = { body: text.innerHTML, title: title ? title.innerHTML : null };
      text.innerHTML = nl2br(tr.body); text.setAttribute('lang', loc);
      if (title && tr.title) title.textContent = tr.title;
      note.textContent = t('translated_from_' + tr.from); note.hidden = false;
      btn.textContent = t('show_original'); li.setAttribute('data-ak-showing', 'translation');
      kuerzen(text); // Übersetzung kann länger oder kürzer sein als das Original
    }
    if (translations[id]) return show(translations[id]);
    btn.disabled = true;
    getJSON(apiOf(host) + '/api/public/translation?id=' + encodeURIComponent(id) + '&lang=' + encodeURIComponent(loc), true)
      .then(function (j) { translations[id] = j; show(j); })
      .catch(function () { note.textContent = t('translate_unavailable'); note.hidden = false; btn.hidden = true; })
      .then(function () { btn.disabled = false; });
  });

  // ---------------------------------------------------------------- Lange Texte kürzen (Weiterlesen wie bei Amazon, 30.10.2026)

  /* Ein Text in der Liste zeigt am Handy 4 Zeilen, ab 750 px 6 (CSS .ak-review__body--kurz); der Rest kommt über „Weiterlesen“.
     Gekürzt wird nur, was wirklich länger ist, und erst durch das Skript: ohne Skript steht der ganze Text da. Die Fotoansicht
     (kein [data-ak-list] darüber) bleibt ungekürzt. Neu gemessen wird nach dem Übersetzen, nach dem Laden der Schrift und bei neuer Breite. */
  function kuerzen(body) {
    if (!body || !body.closest('[data-ak-list]')) return;
    var knopf = body.nextElementSibling && body.nextElementSibling.hasAttribute('data-ak-weiter') ? body.nextElementSibling : null;
    var offen = body.getAttribute('data-ak-offen') === '1'; // aufgeklappt bleibt aufgeklappt, gemessen wird trotzdem (kurze Übersetzung: Astra 30.10.2026)
    body.classList.add('ak-review__body--kurz');
    var zuLang = body.clientHeight > 0 && body.scrollHeight > body.clientHeight + 2; // 0 = nicht gezeichnet (zurückgehalten): ganz zeigen, später neu messen
    if (!zuLang) { // data-ak-offen bleibt: zurück zum langen Original steht der Text wieder offen da
      body.classList.remove('ak-review__body--kurz');
      if (knopf) knopf.parentNode.removeChild(knopf);
      return;
    }
    if (!knopf) body.insertAdjacentHTML('afterend', '<button type="button" class="ak-link ak-review__weiter" data-ak-weiter aria-expanded="' + offen + '">' + esc(t(offen ? 'read_less' : 'read_more')) + '</button>');
    if (offen) body.classList.remove('ak-review__body--kurz');
  }
  function kuerzenIn(scope) { Array.prototype.forEach.call(scope.querySelectorAll('[data-ak-list] [data-ak-text]'), kuerzen); }

  document.addEventListener('click', function (ev) {
    var knopf = ev.target.closest && ev.target.closest('[data-ak-weiter]');
    if (!knopf) return;
    var body = knopf.previousElementSibling, offen = knopf.getAttribute('aria-expanded') !== 'true';
    body.classList.toggle('ak-review__body--kurz', !offen);
    if (offen) body.setAttribute('data-ak-offen', '1'); else body.removeAttribute('data-ak-offen');
    knopf.setAttribute('aria-expanded', String(offen));
    knopf.textContent = t(offen ? 'read_less' : 'read_more');
    // Beim Zuklappen eines langen Texts stünde man sonst mitten in der nächsten Bewertung
    var li = knopf.closest('.ak-review');
    if (!offen && li && li.getBoundingClientRect().top < 0) li.scrollIntoView({ block: 'start' });
  });

  var kuerzenBreite = window.innerWidth, kuerzenUhr = 0;
  window.addEventListener('resize', function () {
    if (window.innerWidth === kuerzenBreite) return; // Handy: die Adressleiste ändert nur die Höhe
    kuerzenBreite = window.innerWidth;
    clearTimeout(kuerzenUhr);
    kuerzenUhr = setTimeout(function () { kuerzenIn(document); }, 200);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { kuerzenIn(document); });

  // ---------------------------------------------------------------- Fotoansicht (Galerie und Medien an der Bewertung)

  var box = null, stage, caption, prevBtn, nextBtn, items = [], index = 0, lastFocus = null;
  function lightbox() {
    if (box) return box;
    box = document.createElement('dialog');
    box.className = 'ak-lightbox';
    box.innerHTML = '<div class="ak-lightbox__inner"><button type="button" class="ak-lightbox__close" data-ak-close aria-label="' + esc(t('lightbox_close')) + '">×</button>' +
      '<div class="ak-lightbox__stage"><div class="ak-lightbox__media" data-ak-stage></div>' +
      '<button type="button" class="ak-lightbox__nav ak-lightbox__nav--prev" data-ak-lb="-1" aria-label="' + esc(t('lightbox_prev')) + '">‹</button>' +
      '<button type="button" class="ak-lightbox__nav ak-lightbox__nav--next" data-ak-lb="1" aria-label="' + esc(t('lightbox_next')) + '">›</button></div>' +
      '<div class="ak-lightbox__caption" data-ak-caption></div></div>';
    document.body.appendChild(box);
    stage = box.querySelector('[data-ak-stage]'); caption = box.querySelector('[data-ak-caption]');
    prevBtn = box.querySelector('[data-ak-lb="-1"]'); nextBtn = box.querySelector('[data-ak-lb="1"]');
    box.addEventListener('click', function (ev) {
      var lu = ev.target.closest('[data-ak-lieferumfang]');
      if (lu) {
        var luZiel = lieferumfangZiel(t('lieferumfang_titel'));
        ev.preventDefault();
        lastFocus = null; // sonst scrollt der Fokus zurück zum Foto
        box.close();
        if (luZiel) luZiel.scrollIntoView({ block: 'start' });
        return;
      }
      var sprung = ev.target.closest('.ak-lightbox__jump');
      if (sprung) {
        // Zur Bewertung springen: der Fokus darf danach nicht aufs Vorschaubild zurück, sonst scrollt die Seite wieder hoch
        var ziel = document.getElementById(sprung.getAttribute('href').slice(1));
        ev.preventDefault();
        lastFocus = null;
        box.close();
        if (ziel) {
          if (!ziel.hasAttribute('tabindex')) ziel.setAttribute('tabindex', '-1');
          ziel.scrollIntoView({ block: 'start' });
          ziel.focus({ preventScroll: true });
        }
        return;
      }
      if (ev.target === box || ev.target.closest('[data-ak-close]')) return box.close();
      var nav = ev.target.closest('[data-ak-lb]');
      if (nav) step(Number(nav.getAttribute('data-ak-lb')));
    });
    box.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowLeft') step(-1);
      if (ev.key === 'ArrowRight') step(1);
    });
    box.addEventListener('close', function () { stage.innerHTML = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); });
    return box;
  }
  function step(d) { if (items.length < 2) return; index = (index + d + items.length) % items.length; renderMedia(); }
  /* Neben dem Bild steht die Bewertung wie in der Liste (Vladi 16.09.2026): Name, Sterne, Titel, Datum, Plakette, Text
     und der Übersetzen-Knopf. Der Knopf wird vom selben Zuhörer bedient wie in der Liste, deshalb
     trägt der Kasten data-review-id und der Dialog data-api/data-locale. */
  /* Überschrift „Lieferumfang“ der Produktbeschreibung, nicht im Bewertungsbereich. lieferumfang_titel nennt je Sprache die
     Anfänge, die in den Produkttexten vorkommen („Scope of delivery|What's included|…“, erhoben 25.09.2026 auf den 80 Produkten
     mit Kachel), der erste ist der Text, wenn die Seite keine solche Überschrift hat. */
  function norm(s) { return String(s || '').replace(/[’‘]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase(); }
  function lieferumfangZiel(titel) {
    var anfaenge = String(titel || '').split('|').map(norm).filter(Boolean);
    if (!anfaenge.length) return null;
    var kandidaten = document.querySelectorAll('main h2, main h3, main h4');
    for (var i = 0; i < kandidaten.length; i++) {
      var k = kandidaten[i], text = norm(k.textContent);
      if (k.closest('[data-ak-reviews], .ak-lightbox')) continue;
      for (var j = 0; j < anfaenge.length; j++) if (text.indexOf(anfaenge[j]) === 0) return k;
    }
    return null;
  }
  function reviewPanel(b, loc) {
    var a = function (n) { return b.getAttribute(n); };
    var titel = hat(a('data-title')) ? a('data-title') : '', verified = a('data-verified'), fuer = a('data-product'), lang = a('data-lang') || '';
    // ak-kundenfotos #3231: Kundenfotos zeigen oft Kamera oder fremdes Zubehör mit, deshalb über jeder Bewertung der Hinweis zum Lieferumfang
    // „Lieferumfang“ als Link zur gleichnamigen Überschrift der Produktbeschreibung; gibt es sie auf der Seite nicht, reiner Text
    // (Nutzerblick 25.09.2026: „steht in der Beschreibung“ schickte zur Überschrift „Beschreibung“, die Liste steht darüber)
    var ziel = lieferumfangZiel(t('lieferumfang_titel')), luTitel = ziel ? ziel.textContent.trim() : t('lieferumfang_titel').split('|')[0];
    var teile = t(a('data-kind') === 'video' ? 'lb_hinweis_video' : 'lb_hinweis').split('__ziel__');
    var h = '<p class="ak-lightbox__hinweis">' + teile.map(esc).join(ziel ? '<a href="#" data-ak-lieferumfang>' + esc(luTitel) + '</a>' : esc(luTitel)) + '</p>' +
      '<div class="ak-review" data-review-id="' + esc(a('data-review') || '') + '" data-lang="' + esc(lang) + '">' +
      '<p class="ak-review__name">' + esc(a('data-name')) + verifiedText({ verified: !!verified, verifiedBy: verified }) + '</p>' +
      '<div class="ak-review__rating">' + stars(a('data-rating'), 'sm') + '</div>' +
      (titel ? '<h3 class="ak-review__title" data-ak-title>' + esc(titel) + '</h3>' : '') +
      '<p class="ak-review__meta"><time datetime="' + esc(a('data-date') || '') + '">' + esc(a('data-date-text') || '') + '</time>' +
      (a('data-source') === 'shop' ? '<span class="ak-review__shop">' + esc(t('shop_review')) + '</span>' : '') +
      (a('data-source') === 'amazon' ? '<span class="ak-review__source">' + esc(t('amazon_review')) + '</span>' : '') +
      (a('data-tester') ? '<span class="ak-review__source">' + esc(t('tester')) + '</span>' : '') + '</p>' +
      (fuer ? '<p class="ak-review__for">' + esc(fuer) + '</p>' : '') +
      '<p class="ak-review__body" data-ak-text>' + nl2br(a('data-body') || '') + '</p>';
    if (lang && lang !== loc) h += '<p class="ak-review__translate"><button type="button" class="ak-link" data-ak-translate>' + esc(t('translate')) + '</button> <span class="ak-review__translated" data-ak-translated hidden></span></p>';
    h += '</div>';
    if (items.length > 1) h += '<p class="ak-lightbox__count">' + esc(t('lightbox_count', { n: index + 1, total: items.length })) + '</p>';
    var id = a('data-review');
    // Aus der Kundenfoto-Kachel geöffnet kein „Zurück zur Liste“: die Käuferin kam aus der Galerie, der Sprung führte tief in die Liste (Nutzerblick 25.09.2026)
    if (id && document.getElementById('bewertung-' + id) && !b.closest('[data-ak-kundenfotos]')) h += '<a class="ak-lightbox__jump" href="#bewertung-' + esc(id) + '">' + esc(t('lightbox_jump')) + '</a>';
    return h;
  }
  function renderMedia() {
    var b = items[index], loc = box.getAttribute('data-locale') || 'de';
    var kind = b.getAttribute('data-kind'), src = b.getAttribute('data-src');
    stage.innerHTML = kind === 'video' ? '<video src="' + esc(src) + '" controls playsinline preload="metadata"></video>' : '<img src="' + esc(src) + '" alt="">';
    caption.innerHTML = reviewPanel(b, loc);
    prevBtn.hidden = nextBtn.hidden = items.length < 2;
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-ak-media]');
    if (!b) return;
    var group = b.closest('[data-ak-media-group]'), host = b.closest('[data-api]');
    items = group ? Array.prototype.slice.call(group.querySelectorAll('[data-ak-media]')) : [b];
    index = Math.max(0, items.indexOf(b)); lastFocus = b;
    lightbox();
    box.setAttribute('data-api', host ? apiOf(host) : 'https://bewerten.ausgeknipst.de');
    box.setAttribute('data-locale', (host && host.getAttribute('data-locale')) || 'de');
    renderMedia();
    if (typeof box.showModal === 'function') box.showModal(); else box.setAttribute('open', '');
  });

  // ---------------------------------------------------------------- Liste: Produktseite und Sammelseite

  function initReviews(root) {
    var mode = root.getAttribute('data-mode'), loc = root.getAttribute('data-locale') || 'de', api = apiOf(root);
    var pid = root.getAttribute('data-product-id') || '', rootPath = root.getAttribute('data-root') || '';
    var per = mode === 'all' ? Math.min(50, Number(root.getAttribute('data-per')) || 20) : 10;
    var list = root.querySelector('[data-ak-list]'), more = root.querySelector('[data-ak-more]'), empty = root.querySelector('[data-ak-empty]');
    var bar = root.querySelector('[data-ak-toolbar]'), status = root.querySelector('[data-ak-status]'), reset = root.querySelector('[data-ak-reset]');
    var sortSel = root.querySelector('[data-ak-sort]'), onlyMedia = root.querySelector('[data-ak-only-media]');
    // Voreinstellung wie im Auswahlfeld und in lib/anzeige-plan.ts: Video, dann Bild, dann beste Sterne
    var state = { sort: 'empfohlen', stars: null, media: false, type: 'product', page: 1, shown: 0, total: 0, seq: 0 };
    var seen = {};

    /* Produktseite am Handy: erst 5 Bewertungen, die übrigen der ersten Seite deckt „Mehr Bewertungen laden“ auf, erst danach lädt der
       Knopf weitere Seiten (30.10.2026, Seite war zur Hälfte Bewertungen). Schnitt, Verteilung samt Sternfilter und Sortierung bleiben oben. */
    var ERST_HANDY = 5;
    function zurueckhalten() {
      if (mode === 'all' || !window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
      var items = list.querySelectorAll('.ak-review');
      for (var i = ERST_HANDY; i < items.length; i++) items[i].classList.add('ak-review--spaeter');
      if (more && items.length > ERST_HANDY) more.hidden = false;
    }
    /* true nur, wenn wirklich etwas verborgen war: ab 750 px (Handy quer gedreht) zeigt das CSS die Karten ohnehin, dann lädt der Knopf weiter (Astra 30.10.2026) */
    function aufdecken() {
      var spaeter = list.querySelectorAll('.ak-review--spaeter');
      if (!spaeter.length) return false;
      var warVerborgen = spaeter[0].offsetParent === null;
      Array.prototype.forEach.call(spaeter, function (li) { li.classList.remove('ak-review--spaeter'); });
      if (more) more.hidden = state.shown >= state.total;
      kuerzenIn(list);
      return warVerborgen;
    }

    function filtered() { return !!(state.stars || state.media); }
    function syncControls() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-ak-star]'), function (b) { b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-ak-star')) === state.stars)); });
      if (reset) reset.hidden = !filtered();
      if (status) status.textContent = filtered() ? (state.total ? tn('reviews', state.total) : t('no_results')) : '';
    }
    function url(page) {
      var q = 'page=' + page + '&per=' + per + '&sort=' + state.sort + '&lang=' + encodeURIComponent(loc);
      q += pid ? '&product=' + encodeURIComponent(pid) : '&type=' + state.type;
      if (state.stars) q += '&stars=' + state.stars;
      if (state.media) q += '&media=1';
      return api + '/api/public/reviews?' + q;
    }
    function load(replace) {
      if (replace) zielLauf++; // neue Auswahl (Filter, Sortierung, Reiter) beendet eine laufende Sprungsuche
      var my = ++state.seq, page = replace ? 1 : state.page + 1;
      if (more) more.disabled = true;
      if (replace) root.classList.add('is-loading');
      return getJSON(url(page), false).then(function (j) {
        if (my !== state.seq) return; // von einer neueren Auswahl überholt
        if (replace) { list.innerHTML = ''; seen = {}; state.shown = 0; }
        var html = '';
        (j.reviews || []).forEach(function (r) {
          if (seen[r.id]) return;
          seen[r.id] = true;
          if (r.translation) translations[r.id] = r.translation; else delete translations[r.id];
          html += card(r, loc, { withProduct: mode === 'all', root: rootPath });
          state.shown++;
        });
        list.insertAdjacentHTML('beforeend', html);
        state.page = page; state.total = j.total || 0;
        if (more) more.hidden = state.shown >= state.total;
        if (replace) zurueckhalten();
        kuerzenIn(list);
        if (empty) empty.hidden = !(state.total === 0 && !filtered());
        syncControls();
      }).catch(function () {
        if (my !== state.seq) return;
        if (status) status.textContent = t('load_error');
        // Die Liste zeigt noch die alte Auswahl, der Zustand schon die neue: „Mehr laden“ hätte gemischt angehängt (Astra 15.09.)
        if (replace && more) { more.hidden = true; state.page = 0; state.shown = 0; }
      }).then(function () {
        if (my !== state.seq) return;
        if (more) more.disabled = false;
        root.classList.remove('is-loading');
      });
    }

    /* Sprung auf eine Bewertung (#bewertung-<id>, Link aus dem Bewertungs-Tool, 23.09.2026): steht sie noch nicht in der Liste,
       Seiten nachladen, bis sie da ist (höchstens 20), dann hinscrollen und markieren. Ohne Sprungmarke passiert nichts. */
    var zielLauf = 0;
    function zumZiel(versuche, lauf) {
      if (lauf == null) lauf = ++zielLauf; else if (lauf !== zielLauf) return; // vom Nutzer überholt (Astra 23.09.2026)
      var m = /^#bewertung-([A-Za-z0-9_-]{1,64})$/.exec(location.hash || '');
      if (!m) return;
      var el = document.getElementById('bewertung-' + m[1]);
      if (el) { if (el.classList.contains('ak-review--spaeter')) aufdecken(); el.classList.add('ak-review--ziel'); el.scrollIntoView({ block: 'center' }); return; }
      if (versuche <= 0 || state.shown >= state.total) return;
      load(false).then(function () { zumZiel(versuche - 1, lauf); });
    }

    function enable(count) {
      if (bar) bar.hidden = !(count > 0);
      if (empty) empty.hidden = count !== 0;
    }

    root.addEventListener('click', function (ev) {
      var star = ev.target.closest('[data-ak-star]');
      if (star && !star.disabled) {
        var s = Number(star.getAttribute('data-ak-star'));
        state.stars = state.stars === s ? null : s;
        load(true);
        (bar || list).scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        return;
      }
      var schreib = ev.target.closest('[data-ak-write]');
      if (schreib) {
        var panel = root.querySelector('#' + schreib.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !panel.hidden;
          schreib.setAttribute('aria-expanded', String(!panel.hidden));
          schreib.textContent = t(panel.hidden ? 'write_review' : 'lightbox_close'); // wie Judge.me: offen heißt der Knopf „Schließen“
        }
        return;
      }
      if (ev.target.closest('[data-ak-reset]')) { state.stars = null; state.media = false; if (onlyMedia) onlyMedia.checked = false; load(true); return; }
      if (ev.target.closest('[data-ak-more]')) { zielLauf++; if (!aufdecken()) load(false); return; }
      var tab = ev.target.closest('[data-ak-type]');
      if (tab && tab.getAttribute('aria-selected') !== 'true') {
        state.type = tab.getAttribute('data-ak-type');
        Array.prototype.forEach.call(root.querySelectorAll('[data-ak-type]'), function (b) { b.setAttribute('aria-selected', String(b === tab)); });
        var hint = root.querySelector('[data-ak-tab-hint]');
        if (hint) hint.hidden = state.type !== 'shop';
        var shopHint = root.querySelector('[data-ak-write-shop]');
        if (shopHint) shopHint.hidden = state.type !== 'shop';
        load(true);
      }
    });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; load(true); });
    if (onlyMedia) onlyMedia.addEventListener('change', function () { state.media = onlyMedia.checked; load(true); });

    if (mode === 'all') {
      if (bar) bar.hidden = false;
      if (root.getAttribute('data-ssr') !== '1') {
        getJSON(api + '/api/public/summary', true).then(function (s) {
          var head = root.querySelector('[data-ak-head]');
          if (head && s.count) head.innerHTML = summaryHTML(s, loc, '') + factsHTML(s);
          var gal = root.querySelector('[data-ak-gallery-slot]');
          if (gal) gal.innerHTML = galleryHTML(s.gallery, loc);
          var counts = root.querySelectorAll('[data-ak-tab-count]');
          if (counts[0]) counts[0].textContent = '(' + (s.products + (s.amazon || 0)) + ')';
          if (counts[1]) counts[1].textContent = '(' + s.shop + ')';
        }).catch(function () {});
      }
      load(true).then(function () { zumZiel(20); });
      return;
    }

    // Produktseite: die ersten 10 kamen aus dem Metafeld; ohne Metafeld baut das Skript denselben Inhalt aus der API.
    Array.prototype.forEach.call(list.querySelectorAll('[data-review-id]'), function (li) { seen[li.getAttribute('data-review-id')] = true; state.shown++; });
    if (root.getAttribute('data-ssr') === '1') {
      state.total = Number(root.getAttribute('data-total')) || 0;
      enable(state.total);
      zurueckhalten();
      kuerzenIn(list);
      zumZiel(20);
      return;
    }
    getJSON(api + '/api/public/summary?product=' + encodeURIComponent(pid), true).then(function (d) {
      state.total = d.total != null ? d.total : (d.count || 0);
      var slot = root.querySelector('[data-ak-summary-slot]'), gal = root.querySelector('[data-ak-gallery-slot]');
      if (slot && d.count) slot.innerHTML = summaryHTML(d, loc, root.getAttribute('data-reviews-page'));
      if (gal && !gal.hasAttribute('data-off')) gal.innerHTML = galleryHTML(d.gallery, loc);
      list.innerHTML = ''; seen = {}; state.shown = 0;
      list.insertAdjacentHTML('beforeend', (d.reviews || []).map(function (r) { seen[r.id] = true; state.shown++; return card(r, loc, { withProduct: false, root: rootPath }); }).join(''));
      if (more) more.hidden = state.shown >= state.total;
      enable(state.total);
      zurueckhalten();
      kuerzenIn(list);
      zumZiel(20);
    }).catch(function () { if (empty) { empty.textContent = t('load_error'); empty.hidden = false; } });
  }

  // ---------------------------------------------------------------- Karussells (unter dem Titel, Startseite)

  function initCarousel(root) {
    var kind = root.getAttribute('data-ak-carousel'), track = root.querySelector('[data-ak-track]');
    var prev = root.querySelector('[data-ak-prev]'), next = root.querySelector('[data-ak-next]');
    var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var reduced = function () { return !!(motion && motion.matches); };
    var halt = { maus: false, fokus: false, beruehrt: false };

    function slideWidth() {
      var first = track.querySelector('[data-ak-slide]');
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    function go(dir) {
      if (dir > 0 && atEnd()) track.scrollTo({ left: 0, behavior: reduced() ? 'auto' : 'smooth' });
      else if (dir < 0 && track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth, behavior: reduced() ? 'auto' : 'smooth' });
      else track.scrollBy({ left: dir * slideWidth(), behavior: reduced() ? 'auto' : 'smooth' });
    }
    function arrows() { var fits = track.scrollWidth <= track.clientWidth + 4; prev.hidden = next.hidden = fits; }
    function ready() {
      if (!track.querySelector('[data-ak-slide]')) { root.hidden = true; return; }
      root.hidden = false;
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      arrows();
      window.addEventListener('resize', arrows);
      if (kind === 'snippet') {
        root.addEventListener('mouseenter', function () { halt.maus = true; });
        root.addEventListener('mouseleave', function () { halt.maus = false; });
        root.addEventListener('focusin', function () { halt.fokus = true; });
        root.addEventListener('focusout', function (ev) { halt.fokus = root.contains(ev.relatedTarget); });
        root.addEventListener('touchstart', function () { halt.beruehrt = true; }, { passive: true }); // bleibt stehen: wer wischt, liest
        setInterval(function () {
          if (reduced() || halt.maus || halt.fokus || halt.beruehrt || document.hidden || track.scrollWidth <= track.clientWidth + 4) return;
          go(1);
        }, 6000);
      }
    }
    if (root.getAttribute('data-ssr') === '1') return ready();
    var api = apiOf(root), pid = root.getAttribute('data-product-id');
    getJSON(api + '/api/public/summary' + (kind === 'snippet' ? '?product=' + encodeURIComponent(pid) : ''), true).then(function (s) {
      var rootPath = root.getAttribute('data-root') || '', loc = root.getAttribute('data-locale') || 'de';
      // Wie im Liquid: Bewertungen in der Sprache der Seite zuerst (sort ist stabil, sonst bleibt die Auswahlreihenfolge)
      var eigeneZuerst = function (list) { return (list || []).slice().sort(function (a, b) { return (a.language === loc ? 0 : 1) - (b.language === loc ? 0 : 1); }); };
      track.innerHTML = kind === 'snippet'
        ? eigeneZuerst(s.highlights).map(snippetHTML).join('')
        : eigeneZuerst(s.featured).map(function (f) { return featuredHTML(f, rootPath); }).join('');
      ready();
    }).catch(function () { root.hidden = true; });
  }

  /* Rutscht der Link „… verifiziert · Rabattcode …“ in eine eigene Zeile, steht er mittig ohne Trennstrich (#3195, CSS
     .ak-banner--gestapelt). Neu prüfen bei jeder Größenänderung und nach dem Laden der Schrift. */
  function bannerZeilen(root) {
    function pruefen() {
      var main = root.querySelector('.ak-banner__main'), how = root.querySelector('.ak-banner__how');
      if (!main || !how) return;
      root.classList.toggle('ak-banner--gestapelt', how.getBoundingClientRect().top >= main.getBoundingClientRect().bottom - 2);
    }
    pruefen();
    if (window.ResizeObserver) new ResizeObserver(pruefen).observe(root); else window.addEventListener('resize', pruefen);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(pruefen);
  }

  function initBanner(root) {
    if (root.getAttribute('data-ssr') === '1') { bannerZeilen(root); return; }
    getJSON(apiOf(root) + '/api/public/summary', true).then(function (s) {
      if (!s.count) return;
      root.insertAdjacentHTML('beforeend', bannerHTML(s, root.getAttribute('data-locale') || 'de', root.getAttribute('data-reviews-page') || '/pages/reviews'));
      bannerZeilen(root);
    }).catch(function () {});
  }

  function initBadge(root) {
    getJSON(apiOf(root) + '/api/public/summary?product=' + encodeURIComponent(root.getAttribute('data-product-id')), true).then(function (d) {
      if (!d.count) return;
      root.innerHTML = stars(d.rating, 'sm') + '<span class="ak-badge__count">' + esc(tn('reviews', d.count)) + '</span>';
      root.hidden = false;
    }).catch(function () {});
  }

  function initIn(scope) {
    function each(sel, fn) {
      Array.prototype.forEach.call(scope.querySelectorAll(sel), function (el) {
        if (el.getAttribute('data-ak-ready')) return;
        el.setAttribute('data-ak-ready', '1');
        fn(el);
      });
    }
    each('[data-ak-reviews]', initReviews);
    each('[data-ak-carousel]', initCarousel);
    each('[data-ak-banner]', initBanner);
    each('[data-ak-badge]', initBadge);
    each('[data-ak-kundenfotos]', initKachel);
  }
  // ak-kundenfotos #3231
  // ---------------------------------------------------------------- Kundenfoto-Kachel in der Produktgalerie und Messpunkte

  /* Die Kachel lädt zuerst die 400-px-Vorschaubilder; sobald sie zu sehen ist und die Fläche mehr Pixel braucht, das große Bild. */
  function kachelScharf(kachel) {
    Array.prototype.forEach.call(kachel.querySelectorAll('img[data-ak-voll]'), function (img) {
      var voll = img.getAttribute('data-ak-voll');
      if (!voll || img.getAttribute('src') === voll || img.clientWidth * (window.devicePixelRatio || 1) <= 420) return;
      var neu = new Image();
      neu.onload = function () { img.src = voll; };
      neu.src = voll;
    });
  }
  function initKachel(kachel) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); kachelScharf(kachel); } });
    }, { threshold: 0.25 });
    io.observe(kachel);
  }

  /* Die Überschrift „Kundenfotos (n)“ öffnet die Fotoansicht beim ersten Foto. */
  document.addEventListener('click', function (ev) {
    var titel = ev.target.closest && ev.target.closest('[data-ak-kf-oeffnen]');
    if (!titel) return;
    var erstes = titel.closest('[data-ak-kundenfotos]').querySelector('[data-ak-media]');
    if (erstes) erstes.click();
  });

  /* Zwei GA4-Messpunkte (Messplan #3231): Tipp auf die Kachel (Foto, Überschrift oder ihr Vorschaubild) und Tipp im Karussell unter
     dem Titel (Bewertung oder Pfeil), je Seitenaufruf höchstens einmal. gtag gibt es erst nach der Cookie-Zustimmung (die Google-App
     lädt es dann), ohne Zustimmung wird nichts gesendet. send_to nur an GA4, nicht an die Google-Ads-Ziele derselben Seite. */
  var GA4 = 'G-DV52LYBY4W', gemessen = {};
  function messen(name, werte) {
    if (gemessen[name] || typeof window.gtag !== 'function') return;
    gemessen[name] = true;
    try { window.gtag('event', name, Object.assign({ send_to: GA4 }, werte)); } catch (e) { /* Messung darf nie die Seite stören */ }
  }
  document.addEventListener('click', function (ev) {
    // Nur echte Tipps: die Pfeile auf dem Hauptbild (main-product.liquid) blättern per click() über die Vorschaubilder,
    // und die Überschrift der Kachel öffnet per click() das erste Foto (Astra 25.09.2026)
    if (!ev.isTrusted) return;
    var z = ev.target;
    if (!z || !z.closest) return;
    var kachel = z.closest('[data-ak-kundenfotos]');
    if (kachel && z.closest('[data-ak-media], [data-ak-kf-oeffnen]')) messen('kundenfotos_kachel_tipp', { stelle: 'kachel', fotos: Number(kachel.getAttribute('data-n')) || 0 });
    else if (z.closest('[data-ak-kf-vorschau]')) messen('kundenfotos_kachel_tipp', { stelle: 'vorschaubild' });
    var karussell = z.closest('[data-ak-carousel="snippet"]');
    if (karussell && z.closest('[data-ak-slide], [data-ak-prev], [data-ak-next]')) messen('bewertungskarussell_tipp', { stelle: z.closest('[data-ak-slide]') ? 'bewertung' : 'pfeil' });
  }, true);
  // /ak-kundenfotos

  initIn(document);
  document.addEventListener('shopify:section:load', function (ev) { initIn(ev.target); }); // Theme-Editor
})();
